import React, { SVGProps } from 'react';
import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

import { IconProps } from 'components/assets/Icons/Icons';

/* eslint-disable max-len */
const UsersShareAccountIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="3.80313"
            y="0.708252"
            width="12.7444"
            height="20.5833"
            stroke="#49565D"
            stroke-width="0.75"
        />
        <rect
            x="16.6134"
            y="6.0415"
            width="4.89488"
            height="15.25"
            fill="currentColor"
            stroke="#49565D"
            stroke-width="0.75"
        />
        <mask id="path-3-inside-1_921_22138" fill="white">
            <rect x="5.69644" y="3.73755" width="3.60323" height="3.60411" rx="0.666667" />
        </mask>
        <rect
            x="5.69644"
            y="3.73755"
            width="3.60323"
            height="3.60411"
            rx="0.666667"
            stroke="#49565D"
            stroke-width="1.5"
            mask="url(#path-3-inside-1_921_22138)"
        />
        <mask id="path-4-inside-2_921_22138" fill="white">
            <rect x="5.69644" y="9.19775" width="3.60323" height="3.60411" rx="0.666667" />
        </mask>
        <rect
            x="5.69644"
            y="9.19775"
            width="3.60323"
            height="3.60411"
            rx="0.666667"
            stroke="#49565D"
            stroke-width="1.5"
            mask="url(#path-4-inside-2_921_22138)"
        />
        <mask id="path-5-inside-3_921_22138" fill="white">
            <rect x="5.69644" y="14.658" width="3.60323" height="3.60411" rx="0.666667" />
        </mask>
        <rect
            x="5.69644"
            y="14.658"
            width="3.60323"
            height="3.60411"
            rx="0.666667"
            stroke="#49565D"
            stroke-width="1.5"
            mask="url(#path-5-inside-3_921_22138)"
        />
        <mask id="path-6-inside-4_921_22138" fill="white">
            <rect x="11.0402" y="3.73755" width="3.60323" height="3.60411" rx="0.666667" />
        </mask>
        <rect
            x="11.0402"
            y="3.73755"
            width="3.60323"
            height="3.60411"
            rx="0.666667"
            stroke="#49565D"
            stroke-width="1.5"
            mask="url(#path-6-inside-4_921_22138)"
        />
        <mask id="path-7-inside-5_921_22138" fill="white">
            <rect x="11.0402" y="9.19775" width="3.60323" height="3.60411" rx="0.666667" />
        </mask>
        <rect
            x="11.0402"
            y="9.19775"
            width="3.60323"
            height="3.60411"
            rx="0.666667"
            stroke="#49565D"
            stroke-width="1.5"
            mask="url(#path-7-inside-5_921_22138)"
        />
        <mask id="path-8-inside-6_921_22138" fill="white">
            <rect x="11.0402" y="14.658" width="3.60323" height="3.60411" rx="0.666667" />
        </mask>
        <rect
            x="11.0402"
            y="14.658"
            width="3.60323"
            height="3.60411"
            rx="0.666667"
            stroke="#49565D"
            stroke-width="1.5"
            mask="url(#path-8-inside-6_921_22138)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.4881 21.6665H0.488098V20.6665H24.4881V21.6665Z"
            fill="#49565D"
        />
    </svg>
);

export const UsersShareAccountIcon = (props: IconProps) => (
    <Icon component={UsersShareAccountIconSvg} {...props} />
);
